import { render, staticRenderFns } from "./KanbanRejected.vue?vue&type=template&id=2bed01a0&scoped=true&"
import script from "./KanbanRejected.vue?vue&type=script&lang=js&"
export * from "./KanbanRejected.vue?vue&type=script&lang=js&"
import style0 from "./KanbanRejected.vue?vue&type=style&index=0&id=2bed01a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed01a0",
  null
  
)

export default component.exports